const token = localStorage.getItem("token");
export default {
    // Local development için localhost kullan (HTTP kullanıyoruz çünkü HTTPS sorunlu)
    //apiUrl: "https://localhost:44391/api",
    // HTTPS alternatifi (sertifika sorunu çözülürse kullanılabilir)
    //apiUrl: "https://localhost:5001/api",
    // Production URL'leri (gerekirse açılabilir)
    apiUrl: "https://b2bportalapi.akode.com/api",
    //apiUrl: "https://tosla-api.paratic.com.tr/api",
    headers: {headers: {"Authorization": "Bearer " + token?.replace('"','').replace('"','').toString()},},
}